import React, { Component } from 'react'
class flowchart extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        return <div>Flowchart</div>
    }
}

export default flowchart
